import { render, staticRenderFns } from "./AccountLogisticsAdd.vue?vue&type=template&id=31dbe566&"
import script from "./AccountLogisticsAdd.vue?vue&type=script&lang=js&"
export * from "./AccountLogisticsAdd.vue?vue&type=script&lang=js&"
import style0 from "./AccountLogisticsAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports